import { requester } from '../utils';


export const fetchAllTickets = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/ticket?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};


export const fetchTicketById = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/ticket/${id}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};


export const replyToTicket = (ticketId, content) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/ticket/reply`,
        method: 'PUT',
        withAuth: true,
        data: {
          ticketId,
          content
        }
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const closeTicket = (id) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/ticket/close`,
        method: 'PUT',
        withAuth: true,
        data: {
          id,
        }
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllUserTicketsById = (userId, query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/ticket/user/${userId}?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
